<div class="header">
    <div class="row m-0">
        <div class="container">
            <div class="row my-2 d-flex justify-content-between">
                <div class="col-8 col-lg-3">
                    <div class="d-flex align-items-center">
                        <img src="./assets/images/logo_Luiss.png" class="mr-5" alt="Logo" height="30px">
                        <i class="fa fa-bars cursor-pointer" (click)="openMenu()"></i>
                    </div>
                </div>
                <div class="col-3 col-lg-1 d-block ">
                    <div class="row m-lg-0">
                        <button (click)="helperService.logout()" class="btn btn-outline-dark btn-search w-100">
                            <span>Logout</span>
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <hr>
</div>

<div id="modalMenu" class="modal left" tabindex="-1" role="dialog" aria-labelledby="myModalLabel" aria-hidden="true">
    <div class="modal-dialog" role="document">
        <div class="modal-content">
            <div class="modal-header d-flex justify-content-between align-items-center">
              <h5 class="modal-title" id="exampleModalLabel">Navigazione</h5>
              <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div class="modal-body">
                <!-- <div *ngIf="showTutor">
                    <span class="text-primary cursor-pointer"  (click)="goTo('/tutoring')">Tutor</span>
                    <hr>
                </div>
                <div *ngIf="showLessons">
                    <span class="text-primary cursor-pointer"  (click)="goTo('/lectures')">Lezioni</span>
                    <hr>
                </div>
                <div *ngIf="showPresences">
                    <span class="text-primary cursor-pointer"  (click)="goTo('/presences')">Presenze</span>
                    <hr>
                </div> -->
                <div>
                    <span class="text-primary cursor-pointer" (click)="goTo('/notifications')">Notifiche</span>
                    <hr>
                </div>
                <span class="text-primary cursor-pointer" (click)="goTo('logout')">Logout</span>
            </div>

        </div>
    </div>
</div>